import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";

const OutputFormatDropdown = ({ value, onChange }) => {
  const { t } = useTranslation();
  const OUTPUT_OPTIONS = [
    { id: "auto", name: t("compress.formatAuto") },
    { id: "jpeg", name: t("compress.formatJpeg") },
    { id: "webp", name: t("compress.formatWebp") },
    { id: "png", name: t("compress.formatPng") },
  ];
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const selectedItem = OUTPUT_OPTIONS.find((item) => item.id === value);

  const handleSelect = (id) => {
    onChange(id);
    setOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div
      ref={dropdownRef}
      className="featured-dropdown output-format-dropdown"
      onClick={() => setOpen(!open)}
    >
      <span className="dropdown-selected">
        <span className="dropdown-selected__text">
          {selectedItem?.name || t("compress.selectFormat")}
        </span>
        <i className="fas fa-caret-down dropdown-selected__caret" aria-hidden />
      </span>

      {open && (
        <div className="featured-list">
          {OUTPUT_OPTIONS.map((item) => (
            <div
              key={item.id}
              className={`featured-item ${value === item.id ? "active" : ""}`}
              onClick={(e) => {
                e.stopPropagation();
                handleSelect(item.id);
              }}
            >
              {item.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default OutputFormatDropdown;
